import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { ApiResponse } from '@/api/types'

export interface UserByIdResponse {
  id: number
  empId?: number
  userName?: string
  roleId?: number
  companyId?: number
  createdById?: number
  createdDate?: string
  updatedById?: number | null
  updatedDate?: string | null
}

export interface ApprovalUserItem {
  id: number
  userName?: string
  empId?: number
  branchId?: number
}

/**
 * Approval Route Detail - GetApprovalUsers, GetUserById, ApproveRequest
 */
export class ApprovalRouteDetailService {
  async getUserById(branchId: number, id: number): Promise<UserByIdResponse | null> {
    const url = endpoints.user.getById(branchId, id)
    const response = await apiClient.get<ApiResponse<UserByIdResponse> | UserByIdResponse | any>(url)
    const payload = response.data
    if (payload && typeof payload === 'object') {
      const data = ('data' in payload && payload.data) ? payload.data : payload
      if (data && typeof data === 'object') {
        return {
          id: data.id ?? data.Id ?? 0,
          empId: data.empId ?? data.EmpId,
          userName: data.userName ?? data.UserName,
          roleId: data.roleId ?? data.RoleId,
          companyId: data.companyId ?? data.CompanyId,
          createdById: data.createdById ?? data.CreatedById,
          createdDate: data.createdDate ?? data.CreatedDate,
          updatedById: data.updatedById ?? data.UpdatedById,
          updatedDate: data.updatedDate ?? data.UpdatedDate,
        }
      }
    }
    return null
  }

  async getApprovalUsers(branchId: number, taskId: number): Promise<ApprovalUserItem[]> {
    const url = endpoints.approvalRouteDetail.getApprovalUsers(branchId, taskId)
    const response = await apiClient.get<ApiResponse<ApprovalUserItem[]> | ApprovalUserItem[] | any>(url)
    const payload = response.data
    if (payload && typeof payload === 'object') {
      let arr: any[] = []
      if ('success' in payload && Array.isArray(payload.data)) arr = payload.data
      else if ('data' in payload && Array.isArray(payload.data)) arr = payload.data
      else if (Array.isArray(payload)) arr = payload
      else if (!Array.isArray(payload) && (payload.id || payload.userName)) arr = [payload]
      return arr.map((item: any) => ({
        id: item.id ?? item.Id ?? 0,
        userName: item.userName ?? item.UserName ?? '',
        empId: item.empId ?? item.EmpId,
        branchId: item.branchId ?? item.BranchId,
      }))
    }
    return []
  }

  async approveRequest(id: number, approvalNote: string, approvalStatusId: number): Promise<void> {
    const url = endpoints.approvalRouteDetail.approveRequest(id, approvalNote, approvalStatusId)
    await apiClient.put(url)
  }
}

export const approvalRouteDetailService = new ApprovalRouteDetailService()
